import React from 'react';
import moment from 'moment';

import { getAgendaData } from 'helpers/agendaHelpers';
import render from './AgendaRender';

export class Agenda extends React.Component {
  static defaultProps = {
    render,
  };

  state = {
    filters: {
      zones: ['all'],
      activities: ['all'],
      status: ['all'],
    },
    date: moment(),
    data: {},
  };


  componentDidMount () {
    this.fetchData(moment(this.state.date).format('YYYY-M'));
  }

  componentDidUpdate (prevProps, { date: prevDate }) {
    const { date } = this.state;
    if (prevDate !== date) {
      this.fetchData(moment(date).format('YYYY-M'));
    }
  }

  fetchData = async date => {
    const data = await getAgendaData(date);
    if (this.isCancelled) return;
    this.setState({ data });
  }

  setFilters = filters =>
    this.setState(previousState => ({ filters: { ...previousState.filters, ...filters } }));

  setDate = date => this.setState({ date });

  render () {
    const { render: Render, ...nextProps } = this.props;
    const { filters, date, data } = this.state;
    const { setFilters, setDate } = this;
    const props = {
      ...nextProps,
      filters,
      setFilters,
      setDate,
      data,
      date,
    };

    return <Render {...props} />;
  }
}

export default Agenda;



// WEBPACK FOOTER //
// ./src/components/Agenda/index.js